import {
  Badge,
  Card,
  CardBody,
  Flex,
  Heading,
  HStack,
  Stack,
  Text,
} from '@chakra-ui/react';
import { RiAlertFill } from 'react-icons/ri';
import { RxDoubleArrowRight } from 'react-icons/rx';
import { R$ } from 'shared/helpers/currency';
import { useChangePlanModalContext } from '../ModalContext';

const PlansDetails = () => {
  const { plan, selectedPlan, availableServices } = useChangePlanModalContext();

  const newPlan = availableServices.find(
    (service) => service.id === selectedPlan,
  );

  return (
    <Stack>
      <Heading fontSize="1.25rem" fontWeight={'semibold'} mb={'1rem'}>
        Resumo da troca
      </Heading>
      <Flex justify="space-between">
        <Stack
          p="1.5rem"
          border="1px solid"
          borderColor={'gray.200'}
          rounded={'md'}
          w="20rem"
          minH="8rem"
          overflowY="auto"
        >
          <Flex justify="flex-start">
            <Badge
              display="inline-block"
              whiteSpace="nowrap"
              rounded="full"
              px="2"
              py="0.5"
              fontWeight="semibold"
              background="gray.100"
            >
              Plano atual
            </Badge>
          </Flex>

          <Heading fontSize="1.10rem" fontWeight={'semibold'}>
            {plan?.name || 'N/A'}
          </Heading>
          <HStack
            justify="space-between"
            fontWeight={'normal'}
            color={'gray.500'}
          >
            <Text>{plan?.periodicity === 'monthly' ? 'Mensal' : 'Anual'}</Text>
            <Text>{plan?.value ? R$(plan.value) : 'N/A'}</Text>
          </HStack>
        </Stack>

        <Stack align="center" justify="center">
          <RxDoubleArrowRight size={'1.5rem'} />
        </Stack>

        <Stack
          p="1.5rem"
          border="2px solid"
          borderColor={'#19A1E6'}
          rounded={'md'}
          backgroundColor={'#F1FCFF'}
          w="20rem"
          minH="8rem"
          overflowY="auto"
        >
          <Flex justify="flex-start">
            <Badge
              display="inline-block"
              whiteSpace="nowrap"
              rounded="full"
              px="2"
              py="0.5"
              fontWeight="semibold"
              background="#E1F5FD"
              color="#19A1E6"
            >
              Novo plano
            </Badge>
          </Flex>
          <Heading fontSize="1.10rem" fontWeight={'semibold'}>
            {newPlan?.name || 'N/A'}
          </Heading>
          <HStack
            justify="space-between"
            fontWeight={'normal'}
            color={'gray.500'}
          >
            <Text>
              {newPlan?.periodicity === 'monthly' ? 'Mensal' : 'Anual'}
            </Text>
            <Text>{newPlan?.value ? R$(newPlan.value) : 'N/A'}</Text>
          </HStack>
        </Stack>
      </Flex>

      {newPlan?.periodicity === 'yearly' && (
        <Card bg={'yYellow.100'} mt={'1.5rem'} overflowY="auto">
          <CardBody>
            <HStack gap="1rem" align="center">
              <RiAlertFill color={'#f1c40f'} size={'1.8rem'} />
              <Flex direction="column">
                <Text fontSize="0.9rem" fontWeight="400" color="gray.600">
                  <strong>Atenção!</strong> Ao finalizar a trocar de plano, as
                  seguintes ações serão realizadas:
                  <br />• Um <strong>novo contrato será criado</strong>, com a
                  <strong> cobrança proporcional</strong> ao novo período (+12
                  meses)
                  <br />• O <strong>contrato atual será cancelado</strong> junto
                  com <strong>todas</strong> as cobranças
                </Text>
              </Flex>
            </HStack>
          </CardBody>
        </Card>
      )}
    </Stack>
  );
};

export default PlansDetails;
